import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { last, initial, toPlainObject } from 'lodash';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';
import { PATH_TO_PARTNER } from '../../../services/i18n/constants';
import { FICHE_MARCHAND, FICHE_MARCHAND_OFFLINE } from '../../../services/mea/constants';

import {
    fetchPartnerDetailsIfNeeded,
    fetchOfflinePartnerIfNeeded
} from '../../../services/partner/actions';
import {
    fetchPartnerDiscountsIfNeeded,
    forceFetchDiscounts
} from '../../../services/discount/actions';
import { fetchMeasIfNeeded } from '../../../services/mea/actions';
import { fetchPartnerShopsIfNeeded } from '../../../services/shop/actions';
import { fetchPartnerCouponsIfNeeded } from '../../../services/coupon/actions';
import { fetcheBonsByPartnerId, fetcheFAQByPartnerId } from '../../../services/ebon/actions';

import {
    getPartner,
    getOfflinePartnerByMoId,
    getEbonPartner
} from '../../../services/partner/selector';
import { getI18nByKey } from '../../../services/i18n/selector';
import { getMeasListByTypeId } from '../../../services/mea/selector';

import { isNormalInteger } from '../../../utils/index';
import { displayableCashbackComplete } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams, removeListMarker } from '../../../utils/htmlUtils';

import ShopsMap from './ShopsMap';
import HeaderComponent from './HeaderComponent';
import HeadComponent from '../../HeadComponent';
import StepEbonComponent from './StepEbonComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import DiscountsListComponent from './DiscountsListComponent';
import CouponSectionComponent from './CouponSectionComponent';
import DiscoverOfferComponent from './DiscoverOfferComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import MeaMerchantCardComponent from './MeaMerchantCardComponent';
import EbonSelectorComponent from '../ebon/ebonselector/EbonSelectorComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import { withLoadingCondition } from '../../loading/withLoadingCondition';

import './MerchantCardPage.scss';

const getPartnerIdFromQuery = query => last(query.split('-'));
const getPartnerNameFromQuery = query => initial(query.split('-')).join('-');

export class MerchantCardPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partnerId: -1,
            partnerName: ''
        };
    }

    componentWillMount() {
        this.initPage(
            getPartnerIdFromQuery(this.props.match.params.query),
            getPartnerNameFromQuery(this.props.match.params.query)
        );
    }

    componentDidUpdate(prevProps) {
        const {
            partner,
            ebonPartner,
            history,
            fetching,
            ebonPartnerFetching,
            isOffline,
            isEbon,
            fetchPartnerDetailsIfNeeded,
            fetchOfflinePartnerIfNeeded,
            fetchMeasIfNeeded,
            fetchPartnerShopsIfNeeded,
            shops,
            offlinePartner
        } = this.props;

        if (
            (!isEbon && !fetching && !partner) ||
            (isEbon && !ebonPartnerFetching && !ebonPartner)
        ) {
            history.push(PATH.NOT_FOUND_PATH);
        } else if (partner) {
            fetchPartnerDetailsIfNeeded(partner.id);
        }

        if (prevProps.isOffline !== isOffline && isOffline && !shops && !offlinePartner) {
            fetchPartnerShopsIfNeeded(partner.id);
            fetchMeasIfNeeded(FICHE_MARCHAND_OFFLINE);
            fetchOfflinePartnerIfNeeded(partner.id);
        }
    }

    componentWillReceiveProps = nextProps => {
        const { history, isAuthenticated, forceFetchDiscounts } = this.props;
        const { partnerId, partnerName } = this.state;
        const partnerIdUrl = getPartnerIdFromQuery(nextProps.match.params.query);
        const partnerNameUrl = getPartnerNameFromQuery(nextProps.match.params.query);

        if (!isNormalInteger(partnerIdUrl)) {
            history.push(PATH.NOT_FOUND_PATH);
        } else if (partnerId !== partnerIdUrl && partnerName !== partnerNameUrl) {
            this.initPage(partnerIdUrl, partnerNameUrl);
        }

        if (isAuthenticated !== nextProps.isAuthenticated) {
            forceFetchDiscounts(partnerId);
        }
    };

    initPage(partnerId, partnerName) {
        const {
            fetchMeasIfNeeded,
            fetchPartnerCouponsIfNeeded,
            fetchPartnerDiscountsIfNeeded,
            fetchOfflinePartnerIfNeeded,
            fetcheBonsByPartnerId,
            fetchPartnerShopsIfNeeded,
            fetcheFAQByPartnerId,
            isOffline
        } = this.props;
        this.setState({ partnerId, partnerName });
        fetchMeasIfNeeded(FICHE_MARCHAND);
        fetchPartnerCouponsIfNeeded(partnerId);
        fetchPartnerDiscountsIfNeeded(partnerId);
        fetcheBonsByPartnerId(partnerId);
        fetcheFAQByPartnerId(partnerId);
        if (isOffline) {
            fetchPartnerShopsIfNeeded(partnerId);
            fetchMeasIfNeeded(FICHE_MARCHAND_OFFLINE);
            fetchOfflinePartnerIfNeeded(partnerId);
        }
    }

    renderPage = () => {
        const {
            i18nPage,
            i18nPageHowItWorks,
            merchantCardMea,
            partner,
            offlinePartner,
            CASHBACK,
            partnerDisplayableCashbackComplete,
            match,
            user,
            shops,
            shopStatus,
            ebonPartner,
            ebons,
            ebonFetching,
            shopError,
            faqEbon,
            faqFetching
        } = this.props;

        const { parameters } = ebons;
        const isOffline = match && match.params.type === PATH.OFFLINE;
        const isEbon = match && match.params.type === PATH.EBON;

        const currentPartner = isEbon ? ebonPartner : partner;

        return (
            <div className="flex-container-v">
                <main role="main" className="conteneur conteneur-mobile" id="p-fm">
                    <HeadComponent
                        title={format(
                            i18nPage.TITLE,
                            currentPartner.name,
                            partnerDisplayableCashbackComplete
                        )}
                        description={format(
                            i18nPage.DESCRIPTION,
                            currentPartner.name,
                            partnerDisplayableCashbackComplete
                        )}
                        canonicalLink={`${CONTEXT_ROOT}${PATH.CASHBACK_PATH}/${match.params.type}/${this.state.partnerId}-${this.state.partnerName}`}
                    />
                    <Breadcrumb
                        defaultRoute
                        routes={[
                            {
                                label: isOffline
                                    ? i18nPage.OFFLINE_BREADCRUMB
                                    : isEbon
                                    ? i18nPage.EBON_BREADCRUMB
                                    : i18nPage.ONLINE_BREADCRUMB,
                                route: `${PATH.CASHBACK_PATH}/${match.params.type}`
                            },
                            {
                                label: currentPartner.name,
                                route: `${PATH.MERCHANTPAGE_PATH}${match.params.type}/${this.state.partnerName}-${this.state.partnerId}`
                            }
                        ]}
                    />

                    <h1>{`${CASHBACK} ${isEbon ? i18nPage.EBON_TYPE : ''} ${
                        currentPartner.name
                    }`}</h1>
                    <HeaderComponent
                        id={this.state.partnerId}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />

                    {isEbon && ebons && ebons.ebonDiscount && (
                        <EbonSelectorComponent partner={currentPartner} />
                    )}
                    {!isEbon && (
                        <DiscountsListComponent
                            partnerId={this.state.partnerId}
                            isOffline={isOffline}
                        />
                    )}

                    <div id="conditions" />
                    {!isOffline && !isEbon && partner.conditions && (
                        <section>
                            <h3>{i18nPage.CONDITIONS_TITLE}</h3>
                            <div>{convertHtmlToReactDomWithParams(partner.conditions)}</div>
                        </section>
                    )}
                    {isOffline && offlinePartner && offlinePartner.conditions && (
                        <section>
                            <h3>{i18nPage.CONDITIONS_TITLE}</h3>
                            <div>
                                <p>{i18nPage.CLO_CONDITION}</p>
                                <p>{i18nPage.CLO_CONDITION_2}</p>
                                <p>{convertHtmlToReactDomWithParams(offlinePartner.conditions)}</p>
                            </div>
                        </section>
                    )}
                    {isEbon && faqEbon.length > 0 && faqEbon.filter(f => f.conditions).length > 0 && (
                        <section>
                            <h3>{i18nPage.CONDITIONS_TITLE}</h3>
                            <div>
                                {faqEbon
                                    .filter(f => f.conditions)
                                    .map(f =>
                                        convertHtmlToReactDomWithParams(removeListMarker(f.content))
                                    )}
                            </div>
                        </section>
                    )}

                    <DiscoverOfferComponent
                        partner={partner}
                        isOffline={isOffline}
                        isEbon={isEbon}
                        ebonPartner={ebonPartner}
                    />

                    <MeaMerchantCardComponent
                        mea={merchantCardMea}
                        partner={currentPartner}
                        isOffline={isOffline}
                    />

                    {((!isOffline && !isEbon && partner.conditions) ||
                        (isOffline && offlinePartner && offlinePartner.conditions)) && <hr />}
                    {!isOffline && !isEbon && (
                        <CouponSectionComponent
                            partnerId={this.state.partnerId}
                            partnerName={this.state.partnerName}
                        />
                    )}

                    {isOffline && shops && (
                        <React.Fragment>
                            <ShopsMap
                                user={user}
                                partner={partner}
                                shops={shops}
                                status={shopStatus}
                                error={shopError}
                            />
                            <hr />
                        </React.Fragment>
                    )}

                    {isEbon && parameters && (
                        <React.Fragment>
                            <section>
                                <h3>
                                    {convertHtmlToReactDomWithParams(
                                        i18nPage.WHERE_AND_HOW_TITLE,
                                        currentPartner.name
                                    )}
                                </h3>
                                {ebonFetching ? (
                                    <LoadingComponent />
                                ) : (
                                    <StepEbonComponent
                                        partner={currentPartner}
                                        parameters={parameters}
                                    />
                                )}
                            </section>
                        </React.Fragment>
                    )}

                    {!isEbon && partner.description && (
                        <section>
                            <h3>{`${i18nPage.ABOUT_TITLE} ${partner.name}`}</h3>
                            <div>{convertHtmlToReactDomWithParams(partner.description)}</div>
                        </section>
                    )}
                </main>

                {isEbon && (
                    <React.Fragment>
                        <div className="conteneur help-container grid">
                            <div className="faq-container inbl">
                                <h2 className="faq-bandeau">{i18nPageHowItWorks.QUESTION}</h2>
                                <div className="faq-list-container">
                                    {faqFetching ? (
                                        <div className="loading-div">
                                            <LoadingComponent />
                                        </div>
                                    ) : (
                                        faqEbon.length > 0 &&
                                        faqEbon.map(faq => (
                                            <FaqElementComponent
                                                key={faq.id}
                                                faq={faq}
                                                cssClass="question-comment-ca-marche-page"
                                                noListMarker
                                                isEbonFaq
                                            />
                                        ))
                                    )}
                                </div>
                            </div>
                            <CustomerServiceComponent cssClass="merchantCard" />
                        </div>
                    </React.Fragment>
                )}

                <HowItWorksComponent
                    topShadow
                    showTitle
                    isOffline={isOffline}
                    isEbon={isEbon}
                    cssClass="conteneur conteneur-mobile"
                />
            </div>
        );
    };

    render() {
        const {
            fetching = false,
            partner = null,
            ebonPartnerFetching = false,
            ebonPartner = null,
            isEbon
        } = this.props;
        const mustLoad =
            (!isEbon && (fetching || !partner)) ||
            (isEbon && (ebonPartnerFetching || !ebonPartner));

        return withLoadingCondition(mustLoad, this.renderPage);
    }
}

MerchantCardPage.propTypes = {
    i18nPage: PropTypes.object.isRequired,
    coupons: PropTypes.array,
    discounts: PropTypes.array,
    partner: PropTypes.object,
    match: PropTypes.object.isRequired,
    partnerDisplayableCashbackComplete: PropTypes.string,
    merchantCardMea: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    const isOffline = ownProps.match && ownProps.match.params.type === PATH.OFFLINE;
    const isEbon = ownProps.match && ownProps.match.params.type === PATH.EBON;

    const partnerId = getPartnerIdFromQuery(ownProps.match.params.query);
    const partner = getPartner(state, partnerId);
    const ebonPartner = getEbonPartner(state, Number(partnerId));

    const meaType = isOffline ? FICHE_MARCHAND_OFFLINE : FICHE_MARCHAND;
    const merchantCardMeas = getMeasListByTypeId(state, meaType).filter(
        mea => mea.idPartenaire === Number(partnerId)
    );

    return {
        CASHBACK: state.i18n.common.CASHBACK,
        i18nPage: state.i18n.page.MERCHANTCARD,
        i18nPageHowItWorks: state.i18n.page.HOW_IT_WORKS,
        isAuthenticated: state.authentication.isAuthenticated,
        user: toPlainObject(state.account.user),
        merchantCardMea: merchantCardMeas[0] || null,
        partner,
        isEbon,
        ebons: state.ebon.ebons,
        ebonFetching: state.ebon.ebonsFetching,
        ebonPartner,
        ebonPartners: state.ebon.ebonPartners,
        offlinePartner: getOfflinePartnerByMoId(state, partner && partner.moId),
        partnerDisplayableCashbackComplete: displayableCashbackComplete(
            isEbon ? ebonPartner : partner,
            getI18nByKey(state, PATH_TO_PARTNER),
            isOffline,
            isEbon
        ),
        fetching: state.partner.fetching,
        ebonPartnerFetching: state.ebon.ebonPartnersFetching,
        shops: state.shop.shops[partnerId] ? state.shop.shops[partnerId] : null,
        shopStatus: state.shop.fetching,
        shopError: state.shop.error,
        isOffline: isOffline,
        faqEbon: state.ebon.faq || [],
        faqFetching: state.ebon.faqFetching
    };
};

const mapDispatchToProps = {
    fetchMeasIfNeeded,
    fetchPartnerCouponsIfNeeded,
    fetchPartnerDiscountsIfNeeded,
    forceFetchDiscounts,
    fetchPartnerDetailsIfNeeded,
    fetchOfflinePartnerIfNeeded,
    fetcheBonsByPartnerId,
    fetcheFAQByPartnerId,
    fetchPartnerShopsIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(MerchantCardPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/MerchantCardPage.js